import { useEffect, useState } from "react";

/** Junta classes ignorando o que for falso. Local de propósito: o `shell/` não importa do resto do app. */
export function junta(...partes: Array<string | false | null | undefined>): string {
  return partes.filter(Boolean).join(" ");
}


/** `true` quando a consulta de mídia casa. Começa já com o valor certo (a casca é SPA, sem SSR). */
export function useMidia(consulta: string): boolean {
  const [casa, setCasa] = useState(() => typeof window !== "undefined" && window.matchMedia(consulta).matches);
  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const aoMudar = () => setCasa(mq.matches);
    aoMudar();
    mq.addEventListener("change", aoMudar);
    return () => mq.removeEventListener("change", aoMudar);
  }, [consulta]);
  return casa;
}

/** Texto digitado em campo, em área de texto ou em elemento editável: atalhos de teclado não valem aí. */
export function ehCampoDeTexto(alvo: EventTarget | null): boolean {
  const el = alvo as HTMLElement | null;
  if (!el || !el.tagName) return false;
  const tag = el.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
}
